import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import API_ENDPOINTS from "../../utils/apiEndpoints";

const Payment = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [razorpayLoaded, setRazorpayLoaded] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const token = localStorage.getItem("parentToken");
  const location = useLocation(); // Get the route location

  // console.log(location,"locccccccc");
  // console.log(location.state?.isPending || false,"TFFFF");

  // Load Razorpay script dynamically
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => setRazorpayLoaded(true);
    document.body.appendChild(script);
  }, []);

  // Store payment type in state (prevents re-fetching on reload)
  const [isPendingPayment] = useState(location.state?.isPending || false);

  useEffect(() => {
    const initiatePayment = async () => {
      const endpoint = isPendingPayment
        ? API_ENDPOINTS.INITIATE_PENDING_PAYMENT
        : API_ENDPOINTS.INITIATE_PAYMENT;

      try {
        const response = await axios.post(
          endpoint,
          { student_id: id },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include Bearer Token
            },
          }
        );

        setPaymentData(response.data);
      } catch (error) {
        console.error("Failed to fetch payment details", error);
        setErrorMsg(error.response?.data?.message || error.message || "Failed to initialize payment. Please try again.");
      }
    };

    if (token) {
      initiatePayment();
    } else {
      console.error("Authorization token not found");
      setErrorMsg("You are not logged in. Please login to continue payment.");
    }
  }, []);

  const payNow = () => {
    if (!razorpayLoaded || !paymentData) {
      alert("Razorpay is still loading or payment data is unavailable.");
      return;
    }

    const options = {
      key: paymentData.payload.key,
      amount: paymentData.payload.amount, // Amount in paise
      currency: paymentData.payload.currency,
      name: paymentData.payload.name,
      description: paymentData.payload.description,
      image: paymentData.payload.image,
      order_id: paymentData.payload.order_id,
      prefill: {
        contact: paymentData.payload.prefill.contact,
      },
      theme: {
        color: paymentData.payload.theme.color,
      },
      handler: function (response) {
        // console.log("Razorpay Success Response:", response);

        // Store payment details in sessionStorage
        sessionStorage.setItem(
          "paymentData",
          JSON.stringify({
            payment_id: response.razorpay_payment_id,
            order_id: response.razorpay_order_id,
            signature: response.razorpay_signature,
            status: "success",
          })
        );

        // Navigate to payment response page
        navigate(`/payment-response/${id}`);
      },
      modal: {
        // Handle Payment Failure
        ondismiss: function () {
          // console.log("User closed the payment window or payment failed");
          alert("Payment failed or was canceled.");
          navigate(`/payment/${id}`); // Redirect to payment page
        },
      },
    };

    // console.log("Payment Options:", options);

    const rzp = new window.Razorpay(options);
    rzp.open();
  };



  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-6 rounded-lg shadow-md text-center">
        {/* <h2 className="text-xl font-semibold text-center mb-4">Payment Form</h2> */}
        <p className="w-80 py-5">
          Make the payment by clicking the Pay now button, Once the payment is done you will be redirected to download the
          Prospectus and Admission form.</p>

        {errorMsg ? (
          <div className="bg-red-50 text-red-600 p-4 rounded-lg mb-4 text-sm font-semibold border border-red-200">
            {errorMsg}
          </div>
        ) : (
          <h2 className="text-xl font-bold mb-4">
            {paymentData ? `Rs. ₹${paymentData.amount}/-Only` : "Loading..."}
          </h2>
        )}

        <button
          onClick={payNow}
          className={`px-6 py-3 rounded-lg text-white ${errorMsg ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600'}`}
          disabled={!razorpayLoaded || !paymentData || errorMsg}
        >
          {errorMsg ? "Error" : (razorpayLoaded && paymentData ? "Pay Now" : "Loading...")}
        </button>
      </div>
    </div>
  );
};

export default Payment;
